module.exports = __webpack_public_path__ + "static/media/bg-detail.743ce61d.svg";